document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = Array.from(
    document.getElementsByClassName("product-details__accordion-title")
  );

  accordionItems.forEach((item) => {
    item.addEventListener("click", () => {
      accordionItems
        .filter((it) => it !== item)
        .forEach((element) => {
          element.classList.remove("active");
        });
      item.classList.toggle("active");
    });
  });

  if (location.href.includes("#open-bis")) {
    const bisButton = document.querySelector(".klaviyo-bis-trigger");
    if (bisButton) {
      setTimeout(function () {
        bisButton.click();
      }, 2000);
    }
  }
});
